var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkirt11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66841 2.64414C8.59896 2.22427 8.20489 1.94063 7.78822 2.01061C7.37155 2.08058 7.09007 2.47768 7.15951 2.89755L8.16023 7.94793C7.74132 8.36092 7.18312 8.74209 6.5052 8.89433C6.1868 8.96584 5.94148 9.26864 6.01225 9.58952L6.31244 10.9508C6.4563 11.6031 6.55458 12.4073 6.60714 13.2508C6.61856 13.2503 6.63003 13.25 6.64157 13.25H17.3456C17.3594 13.25 17.3731 13.2504 17.3867 13.2511C17.4326 12.6162 17.5055 12.0199 17.6054 11.5167L17.99 9.57883C18.0531 9.26088 17.8089 8.96635 17.4945 8.89731C16.8106 8.7471 16.2478 8.36363 15.8261 7.94793L16.8268 2.89755C16.8963 2.47768 16.6148 2.08058 16.1981 2.01061C15.7815 1.94063 15.3874 2.22427 15.3179 2.64414L14.3892 7.25932C12.0621 8.38523 10.7147 7.90039 9.60239 7.29105L8.66841 2.64414Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2761 14.75H6.71106L7.01223 18L7.00305 20.9969C7.00136 21.5504 7.44957 22 8.00305 22H15.9937C16.5484 22 16.9972 21.5485 16.9937 20.9937L16.9749 18L17.2761 14.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkirt11);
export default __webpack_public_path__ + "static/media/skirt-11.5ceebff6d1471471f0a9e054d814dc68.svg";
export { ForwardRef as ReactComponent };